/* React Elements */
import React from "react";


const OatmealTwoWays = (props) => {

    const contentStyles = {
        display: props.active
    }

    return (
        <div style={contentStyles} className="column bright-red">
            <div className="flex space-btwn w-one-hundred">
                <h1 className="bright-red sub-title">M</h1>
                <h1 className="bright-red sub-title">A</h1>
                <h1 className="bright-red sub-title">R</h1>
                <h1 className="bright-red sub-title">C</h1>
                <h1 className="bright-red sub-title">H</h1>
            </div>
            <div className="height-150px flex column red-border-bottom">
                <h2 className="uppercase">oatmeal two ways</h2>
                <div>
                    <p className="no-space">Servings: 16*</p>
                    <p className="no-space">Active Prep: 1 hour</p> 
                </div>
            </div>
            <div>
                <div className="flex flex-end">
                    <div className="seventy-percent">
                        <h3>ingredients</h3>
                        <div>
                            <ul>
                                <li>4 cups steel-cut oats</li>
                                <li>2 cups kasha</li>
                                <li>1 cup millet</li>
                                <li>1/2 cult chia seeds</li> 
                                <li>1/2 cup flax seeds</li>
                                <li>Water </li>
                            </ul>
                            <ul>
                                <li>Special equipment</li>
                                <li>Nut milk bag</li>
                            </ul>
                        </div>
                        <div className="flex mobile-column">
                            <div className="fifty-percent">
                                <ul>
                                    <li>For savory toppings:</li>
                                    <li>1/2 lb ground pork</li>
                                    <li>1 shallot</li>
                                    <li>2 cloves garlic</li> 
                                    <li>1/2 tablespoon preserved kumquats, thinly sliced (sub preserved lemons)</li>
                                    <li>1 teaspoon fennel seed</li>
                                    <li>1/2 teaspoon red chili flake</li>
                                    <li>1/2 bunch cilantro, dill, or parsley</li>
                                    <li>4 eggs</li>
                                    <li>Pea shoots, for garnishing</li>
                                    <li>Sambal, hot sauce, or chili crisp (optional)</li>
                                    <li>1/2 cup neutral frying oil</li>
                                </ul>
                            </div>
                            <div className="fifty-percent">
                                <ul>
                                    <li>For sweet toppings:</li>
                                    <li>1 cup sesame seeds (reserve seed pulp after making sesame milk)</li>
                                    <li>2 cups pumpkin seeds</li>
                                    <li>1/2 + 1/4 cup maple syrup</li> 
                                    <li>6 – 7 ripe bananas</li>
                                    <li>1/2 cup dried black mission figs, halved</li>
                                    <li>2 star anise</li>
                                    <li>8 coffee beans</li>
                                    <li>Water</li>
                                    <li>Golden Raisins</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex mobile-column">
                    <div className="twenty-five-percent">
                        <h3>RECIPE NOTES</h3>
                        <p>*The oatmeal blend is enough for 16 servings. The savory toppings are enough for 4 servings, and the sweet 8 servings. As you make your way through the oatmeal blend, choose and prepare your toppings in advance and enjoy throughout the week. A little bit of prep work can make the rest of the week seamless.</p>
                    </div>
                    <div className="seventy-percent">
                        <h3>preparation</h3>
                        <p>For the oatmeal:<br></br>1. In a large bowl, combine the grains and seeds and mix thoroughly. Transfer to a sealable container to store until ready to use.</p>
                        <p>2. Measure 1 cup oatmeal : 3 cups water for 2 servings. Multiply or divide this ratio for more or less servings. Bring to a boil then simmer for 25 minutes stirring frequently. Taste for your desired texture, adding more water for creamier oats or reducing for an extra minute or two for chunkier.</p>
                        <p>3. Add your chosen toppings and enjoy.</p>
                        <br></br>
                        <p>For the savory toppings:<br></br>1. Pick your herbs and set aside in a heat proof bowl.</p>
                        <p>2. Thinly slice both the garlic cloves and the shallot.</p>
                        <p>3. In a small saucepan, heat the neutral frying oil over medium heat. In order to test the temperature, add one slice of garlic to the oil, and if it bubbles and rises to the top, the temperature is hot enough.</p>
                        <p>4. Add the rest of the garlic slices, and gently turn them in the oil while frying with a spoon. Once golden brown, a minute or two, remove with a slotted spoon and reserve in a small bowl. Repeat the same process with the sliced shallots. </p>
                        <p>5. Bring a saucepan of water to a gentle boil.</p>
                        <p>6. Gently drop in the eggs with their shell and set a timer for six minutes. </p>
                        <p>7. When the timer goes off, remove the eggs and immediately run under cold water or place in an ice bath. Time is of the essence to achieve a runny yolk. </p>
                        <p>8. Once cool to the touch, gently peel and set aside until ready to eat. </p>
                        <p>9. Lightly coat the bottom of a sauté pan with neutral oil and place over medium-high heat. Add fennel seed and cook while stirring until fragrant about 1 minute. Add pork and red chili flake. Break apart the pork with a wooden spoon and integrate the spices. </p>
                        <p>10. Allow the pork to settle and caramelize, about three minutes on one side, before turning and continuing to break down. Repeat this process until caramelized throughout.</p>
                        <p>11. Add the pork mixture with any reserved fat to the bowl with the herbs along with the fried garlic, fried shallots, and preserved kumquats. Toss quickly so that the heat gently wilts the herbs but does not cook them. </p>
                        <p>12. On your prepared oatmeal, place a spoonful of the pork mixture, a six-minute egg, pea shoots, and sambal, hot sauce, or chili crisp.</p>
                        <br></br>
                        <p>For sweet toppings:<br></br>1. Soak 1 cup of sesame seeds in 3 cups of water for at least two hours, preferably overnight.</p>
                        <p>2. Add the sesame seeds and water into a blender and blend thoroughly. Over a bowl, strain the liquid through a nut milk bag. Squeeze the bag with the pulp to remove excess liquid and place the pulp in a bowl. Reserve the sesame milk for your oatmeal and coffee.</p>
                        <p>3. In a large pot, peel and break apart the ripe bananas. Add the dried black mission figs, water, ½ cup maple syrup, star anise, and coffee beans. </p>
                        <p>4. Cook over medium heat. Over time, the bananas will become syrupy and the dried figs will soften. After about 30 minutes, the mixture will become thick like jam. Taste and continue to reduce if needed. Otherwise, let cool and place in a sealable container. This jam can be stored for at least a month in the refrigerator.</p>
                        <p>5. Preheat oven to 375 degrees. </p>
                        <p>6. In the bowl with the reserved sesame pulp, add the pumpkin seeds, neutral oil, and ¼ cup maple syrup. Mix gently, allowing for some of the sesame pulp to remain chunky.</p>
                        <p>7. Place in the oven and turn the mixture every five minutes until golden brown. This should take three or four turns, about 20 minutes total. Remove and let cool.</p>
                        <p>8. On your prepared oatmeal, place a spoonful of banana jam, pumpkin seed granola, golden raisins, and sesame milk to your liking. </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OatmealTwoWays;